module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"short_name":"Simulassur","start_url":"/","background_color":"#051039","theme_color":"#ffffff","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2c1281f4732b996879dd58f25096d792"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
